import angular from 'angular';
import uiRouter from 'angular-ui-router';
import radioFormElementComponent from './radioFormElement.component';

let radioFormElementModule = angular.module('radioFormElement', [
  uiRouter
])

.component('radioFormElement', radioFormElementComponent)

.name;

export default radioFormElementModule;
